import { useState, useEffect } from 'react'
import { GachaponOption } from '../types'
import { RollingContainer, AnimatedPixelatedImage, ZOOM_IN_ANIMATION_DURATION } from './styles'

const ROLLING_IMAGES: Record<GachaponOption, { static: string; animation: string }> = {
  hp: {
    static: '/images/vvsGotchi/gachapon-machine-hp.png',
    animation: '/images/vvsGotchi/gachapon-animation-hp.png',
  },
  exp: {
    static: '/images/vvsGotchi/gachapon-machine-xp.png',
    animation: '/images/vvsGotchi/gachapon-animation-xp.png',
  },
}

const ANIMATION_PLAY_DURATION = 3000

const GachaponRolling: React.FC<{
  selection: GachaponOption
  onAnimationPlayedRef: React.MutableRefObject<() => any>
}> = ({ selection, onAnimationPlayedRef }) => {
  const [loaded, setLoaded] = useState(false)
  const [zoomInCompleted, setZoomInCompleted] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setZoomInCompleted(true)
    }, ZOOM_IN_ANIMATION_DURATION)
    return () => clearTimeout(timer)
  }, [])

  const showAnimation = zoomInCompleted && loaded

  useEffect(() => {
    if (!showAnimation) return () => undefined

    const timer = setTimeout(() => {
      onAnimationPlayedRef.current()
    }, ANIMATION_PLAY_DURATION)
    return () => clearTimeout(timer)
  }, [showAnimation, onAnimationPlayedRef])

  return (
    <RollingContainer aspect="800/1080" bg={!showAnimation ? ROLLING_IMAGES[selection].static : null}>
      {zoomInCompleted && (
        <AnimatedPixelatedImage
          show={showAnimation}
          onLoad={() => {
            setLoaded(true)
          }}
          src={ROLLING_IMAGES[selection].animation}
        />
      )}
    </RollingContainer>
  )
}

export default GachaponRolling
